import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@apollo/client/react';

export default function DeleteButton({ resource, mutation, redirectPath, label }) {
  const navigate = useNavigate();
  const [deleteResource] = useMutation(mutation, {
    refetchQueries: [{ query: resource.query }],
    async onCompleted() {
      navigate(redirectPath);
    }
  });

  return (
    <button
      className="btn btn-danger"
      onClick={() => {
        if (confirm(`Delete this ${label}? This cannot be undone.`)) {
          deleteResource({ variables: { input: { id: resource.id } } });
        }
      }}
    >
      <span className="material-symbols-rounded">delete</span>
      Delete {label}
    </button>
  );
}
